import React from "react";
import { useId } from "../../hooks/use-id";
import { FormMessage } from "../../components/shared/form-message";
import departamentos from "../Departamentos";

/**
 * Campo de selección del departamento de expedición del documento.
 *
 * Renderiza un listado desplegable con los departamentos disponibles,
 * registra el campo en React Hook Form y muestra el mensaje de error
 * correspondiente cuando la validación falla.
 *
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.formController - Instancia de React Hook Form utilizada para registrar y validar el campo.
 * @param {Object} props.texts - Objeto con los textos traducidos utilizados en la interfaz.
 *
 * @returns {JSX.Element} InstDepartmentField
 */
export const InstDepartmentField = ({ formController, texts }) => {
    const departamento = useId('departamento');
    
    // Identificador utilizado por React Hook Form para registrar el campo.
    const fieldDepartamento = 'departamento';

    const { institucional } = texts;
    const { form } = institucional;

    const {
        register,
        formState: { errors } } = formController

    return (
        <>
            <label
                htmlFor={departamento}
                className="secondary-item"
            >
                <strong>
                    {form?.departamento?.label || 'Departamento* (Departamento de expedición de cédula):'}
                </strong>
            </label>
            <select
                className="form-control focusable-secondary"
                id={departamento}
                {...register(fieldDepartamento, {
                    required: {
                        value: true,
                        message: form?.departamento?.alert || 'Por favor, escoge un departamento'
                    },
                })}
            >
                <option hidden value="">
                    {form?.departamento?.placeholder || 'Escoge tu departamento'}
                </option>
                {departamentos.map(item => {
                    return (
                        <option key={item} value={item}>{item}</option>
                    )
                })}
            </select>
            <FormMessage
                message={errors[fieldDepartamento]?.message}
                type="error" />
        </>
    )
}